import { Record } from 'immutable';
import PropTypes from 'prop-types';
export const DISJUNCTIVE_FACET_TYPE = 'disjunctive';
export const CONJUNCTIVE_FACET_TYPE = 'conjunctive';
export default class FacetType extends Record({
  algoliaFacetKey: undefined,
  queryType: undefined
}) {
  static disjunctive(algoliaFacetKey) {
    return new FacetType({
      algoliaFacetKey,
      queryType: DISJUNCTIVE_FACET_TYPE
    });
  }
  static conjunctive(algoliaFacetKey) {
    return new FacetType({
      algoliaFacetKey,
      queryType: CONJUNCTIVE_FACET_TYPE
    });
  }
}
export const FacetTypePropType = PropTypes.instanceOf(FacetType);